/**
 * Time formatting utilities for Bahamas local time (EST/EDT)
 */

/**
 * Convert 24-hour time to 12-hour format with AM/PM
 * @param {string} time24 - Time in 24-hour format (HH:MM)
 * @returns {string} Time in 12-hour format (h:MM AM/PM)
 */
export const formatTime12Hour = (time24) => {
  if (!time24) return '';
  
  const [hours, minutes] = time24.split(':');
  const hour = parseInt(hours, 10);
  const min = minutes || '00';
  
  if (hour === 0) {
    return `12:${min} AM`;
  } else if (hour < 12) {
    return `${hour}:${min} AM`;
  } else if (hour === 12) {
    return `12:${min} PM`;
  } else {
    return `${hour - 12}:${min} PM`;
  }
};

/**
 * Get current Nassau/Bahamas local time
 * @returns {string} Current time in Nassau
 */
export const getBahamasTime = () => {
  const now = new Date();
  const bahamasTime = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Nassau',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(now);
  
  return bahamasTime;
};

/**
 * Format date for Bahamas
 * @param {string} dateStr - Date string
 * @returns {string} Formatted date
 */
export const formatBahamasDate = (dateStr) => {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Nassau',
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date);
};
